const EVENT_CLICK = 'Click'
const EVENT_VIEW = 'View'

export default Object.freeze({
  EVENTS: {
    INIT: {
      ViewAboutPage: `${EVENT_VIEW} - About Page`,
      ViewAppDownloadPage: `${EVENT_VIEW} - App Download Page`,
      ViewArticleDetailPage: `${EVENT_VIEW} - Article Detail Page`,
      ViewAutopayTermsPage: `${EVENT_VIEW} - Autopay Terms Page`,
      ViewCardActivationPage: `${EVENT_VIEW} - Card Activation Page`,
      ViewCareersPage: `${EVENT_VIEW} - Careers Page`,
      ViewCashBackProgramTermsDynamicRewardsTabPage: `${EVENT_VIEW} - Dynamic Cash Back Program Terms Tab Page`,
      ViewCashBackProgramTermsDynamicRewardsWebBankPage: `${EVENT_VIEW} - Dynamic Cash Back Program Terms WebBank Page`,
      ViewCashBackProgramTermsStandardTabPage: `${EVENT_VIEW} - Cash Back Program Terms Standard Tab Page`,
      ViewCashBackProgramTermsStandardWebBankPage: `${EVENT_VIEW} - Cash Back Program Terms Standard WebBank Page`,
      ViewCashBackProgramTermsTravelGasDiningTabPage: `${EVENT_VIEW} - Cash Back Program Terms Travel Gas Dining Tab Page`,
      ViewCashBackProgramTermsTravelGasDiningWebBankPage: `${EVENT_VIEW} - Cash Back Program Terms Travel Gas Dining WebBank Page`,
      ViewConsumerPrivacyNoticePage: `${EVENT_VIEW} - Consumer Privacy Notice Page`,
      ViewContactPage: `${EVENT_VIEW} - Contact Page`,
      ViewCustomerIdentityVerificationRequirementsPage: `${EVENT_VIEW} - Customer Identity Verification Requirements Page`,
      ViewDigitalWalletTermsPage: `${EVENT_VIEW} - Digital Wallet Terms Page`,
      ViewEcommDisclosurePage: `${EVENT_VIEW} - Ecomm Disclosure Page`,
      ViewGoldLineCardProductPage: `${EVENT_VIEW} - Gold Line Page`,
      ViewGreenLineCardProductPage: `${EVENT_VIEW} - Green Line Page`,
      ViewLandingPage: `${EVENT_VIEW} - Landing Page`,
      ViewLegalCardholderAgreementsPage: `${EVENT_VIEW} - Cardholder Agreements Page`,
      ViewLegalCashBackTermsPage: `${EVENT_VIEW} - Cash Back Terms Page`,
      ViewLegalPage: `${EVENT_VIEW} - Legal Page`,
      ViewLegalPrivacyAndSecurityPage: `${EVENT_VIEW} - Privacy and Security Page`,
      ViewLicenseDisclosurePage: `${EVENT_VIEW} - License Disclosure Page`,
      ViewMoneyPage: `${EVENT_VIEW} - Money Page`,
      ViewNewsPage: `${EVENT_VIEW} - News Page`,
      ViewNewsWhyCharterPage: `${EVENT_VIEW} - News Why Charter Page`,
      ViewNotFoundPage: `${EVENT_VIEW} - Not Found Page`,
      ViewPrivacyPolicyPage: `${EVENT_VIEW} - Privacy Policy Page`,
      ViewResourcesPage: `${EVENT_VIEW} - Resources Page`,
      ViewSecuredCardProductPage: `${EVENT_VIEW} - Secured Card Page`,
      ViewSecuredCardTabBankCardholderAgreements: `${EVENT_VIEW} - Secured Card TAB Bank Cardholder Agreements Page`,
      ViewSilverLineCardProductPage: `${EVENT_VIEW} - Silver Line Page`,
      ViewTermsOfUsePage: `${EVENT_VIEW} - Terms of Use Page`,
      ViewVisaTabBankCardholderAgreements: `${EVENT_VIEW} - Visa TAB Bank Cardholder Agreements Page`,
      ViewVisaWebBankCardholderAgreements: `${EVENT_VIEW} - Visa WebBank Cardholder Agreements Page`,
    },
    INTERACTION: {
      ClickActivationSignIn: `${EVENT_CLICK} - Activation Sign In Button`,
      ClickActivationFindApp: `${EVENT_CLICK} - Activation Find Application Button`,
      ClickArticleCard: `${EVENT_CLICK} - Article Card`,
      ClickCta: `${EVENT_CLICK} - CTA`,
      ClickFindYourApplication: `${EVENT_CLICK} - Find Your Application Button`,
      ClickGetStarted: `${EVENT_CLICK} - Get Started Button`,
      ClickLogIn: `${EVENT_CLICK} - Account Log In Button`,
      ClickPressEmail: `${EVENT_CLICK} - Press Email Link`,
      ClickRatesAndTermsLink: `${EVENT_CLICK} - Rates and Terms Link`,
      ClickRespondToMailOffer: `${EVENT_CLICK} - Respond to Mail Offer Button`,
      ClickTrustPilotWidget: `${EVENT_CLICK} - Trust Pilot Widget`,
      ClickTestimonialVideo: `${EVENT_CLICK} - Testimonial Video`,
      ClickViewCareers: `${EVENT_CLICK} - View Careers Button`,
      ClickViewOpenings: `${EVENT_CLICK} - View Openings Button`,
    },
  },
})
